module.exports = "<p>\r\n  list-vna-services works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/phone/config/vna_services/components/list-vna-services/list-vna-services.component.html
// module id = ../../../../../src/app/phone/config/vna_services/components/list-vna-services/list-vna-services.component.html
// module chunks = main